module.exports = __webpack_public_path__ + "static/img/women.bc7687f9.svg";